import React, { useState, useEffect } from "react";
import Axios from "axios";
import Swal from "sweetalert2";
import { GetResources, InsertResourceDocs, UpdateResourceDocs } from "../apiconstants/constants";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { useCountry } from "../contexts/countrycodecontext.js";
import { Modal } from "react-bootstrap";
const ListOfResources = () => {
  const [selectedDocType, setSelectedDocType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [documents, setDocuments] = useState([]);
  const {selectedCountry}= useCountry();
const [modalContent, setModalContent] = useState({
  title: "",
  html: null,
  url: null,
});
const [showModal, setShowModal] = useState(false);

  let Guid = "";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const email = localStorage.getItem("email");
  const roleID = localStorage.getItem("roleID");
const token = localStorage.getItem("jwtToken");

  if (roleID == 3) {
    Guid = employerGuid;
  } else {
    Guid = guid;
  }
const isReadOnly = roleID == 3;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedExtensions = /\.(pdf|doc|docx|jpg|jpeg|png|gif|mp4|mov|avi|webm)$/i;
    if (!allowedExtensions.test(file.name)) {
      Swal.fire({
        icon: "error",
        text: "Invalid file type. Only PDF, DOCX, JPG, or PNG or Videos allowed.",
      });
      return;
    }

    setSelectedFile(file);
  };
const handleShowModal1 = async (doc) => {
  if (!doc.filePath) return;

  try {
    const blobUrl = doc.filePath; // You can use this directly if it's already public

    setModalContent({
      title: doc.title,
      url: blobUrl,
    });

    setShowModal(true);
  } catch (err) {
    console.error("Preview failed", err);
    Swal.fire({
      icon: "error",
      text: "Unable to preview the document.",
    });
  }
};


const getAllDocuments = async () => {
  try {
   const res = await Axios.get(GetResources.APIURL, {
  params: { userGuid: Guid },
  headers: { Authorization: `Bearer ${token}` }
});


    // Filter out items with empty or placeholder file paths
    const validDocs = res.data.filter(
      (doc) => doc.filePath && !doc.filePath.includes("{")
    );

    setDocuments(validDocs);
  } catch (err) {
    console.error("Error fetching documents", err);
  }
};
const renderAttachment = (fileUrl) => {
  if (!fileUrl) return <p>No attachment available</p>;

  const fileExtension = fileUrl.split('.').pop().toLowerCase();

  if (fileExtension === 'pdf') {
    return <iframe src={fileUrl} title="PDF Preview" style={{ width: '100%', height: '500px' }} />;
  } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
    return <img src={fileUrl} alt="Image Attachment" style={{ width: '100%' }} />;
  } else if (fileExtension === 'docx' || fileExtension === 'doc') {
    return (
      <iframe
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
        title="DOCX Preview"
        style={{ width: '100%', height: '500px' }}
      />
    );
  } else if (['mp4', 'mov', 'avi', 'webm'].includes(fileExtension)) {
    return (
      <video controls style={{ width: '100%', maxHeight: '500px' }}>
        <source src={fileUrl} type={`video/${fileExtension}`} />
        Your browser does not support the video tag.
      </video>
    );
  } else {
    return (
      <a href={fileUrl} target="_blank" rel="noopener noreferrer">
        Download Attachment
      </a>
    );
  }
};




const handleUpload = async () => {
  if (!selectedDocType || !selectedFile) {
    Swal.fire({
      icon: "warning",
      title: "Missing Data",
      text: "Please select a document type and file.",
    });
    return;
  }

  // // Step 1: Check if a doc with same title exists
  // const existingDoc = documents.find(doc => doc.title === selectedDocType);

  // if (existingDoc) {
  //   // Step 2: Call updateDocument
  //   await updateDocument(existingDoc.resourceID, selectedDocType, selectedFile);
  //   setSelectedFile(null);
  //   setSelectedDocType("");
  //   return;
  // }

  // Step 3: Else Insert new
  const formData = new FormData();
  formData.append("Title", selectedDocType);
  formData.append("CreatedBy", email);
  formData.append("UserGuid", Guid);
  formData.append("File", selectedFile);
  formData.append("CountryID", selectedCountry);


  try {
    const response = await Axios.post(InsertResourceDocs.APIURL, formData,
      { headers: { Authorization: `Bearer ${token}`,      
                   "Content-Type": "multipart/form-data",
                   } }
    );
    Swal.fire({
      icon: "success",
      title: "Uploaded Successfully",
      text: response?.data?.message || "Document uploaded.",
    });
    setSelectedFile(null);
    setSelectedDocType("");
    getAllDocuments(); // Refresh list
  } catch (error) {
    console.error("Upload error:", error);
    Swal.fire({
      icon: "error",
      title: "Upload Failed",
      text: "Please try again later.",
    });
  }
};


const updateDocument = async (resourceId, title, file) => {
  if (!file) return;

  const formData = new FormData();
  formData.append("ResourceID", resourceId);
  formData.append("Title", title);
  formData.append("UserGuid", Guid);
  formData.append("UpdatedBy", email);
  formData.append("File", file);
  formData.append("CountryID", selectedCountry);


  try {
    const res = await Axios.post(UpdateResourceDocs.APIURL, formData,
      { headers: { Authorization: `Bearer ${token}`,      
                   "Content-Type": "multipart/form-data",
                   } }
    );
    Swal.fire({
      icon: "success",
      title: "Document Updated",
      text: res?.data?.message || "Updated successfully",
    });
    getAllDocuments(); // Refresh list after update
  } catch (err) {
    console.error("Update failed", err);
    Swal.fire({
      icon: "error",
      title: "Update Failed",
      text: "Please try again.",
    });
  }
};

  useEffect(() => {
    getAllDocuments();
  }, []);

  return (
    <ConsultantLayout>
       <div className="mt-4">
        
                        <div className="responsive-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <h2 style={{ color: "#00a7ac" }}>Resources</h2>
        
                       
                        </div>
                        <hr/>
                        </div>
     {!isReadOnly && (
  <>
    <select
      className="form-control mb-2 mt-3"
      value={selectedDocType}
      onChange={(e) => setSelectedDocType(e.target.value)}
    >
      <option value="">Select Document Type</option>
      <option value="How it Works">How it Works</option>
      <option value="Resume formats">Resume formats</option>
      <option value="Incentive Structure">Incentive Structure</option>
    </select>

    
  
<input
  type="file"
  className="form-control mb-3 mt-4"
  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.webm"
  onChange={handleFileChange}
/>

    <button className="btn btn-primary" onClick={handleUpload}>
      Upload
    </button>
  </>
)}


   <h5 className="mt-4">Uploaded Documents</h5>
<table style={{fontSize:14}} className="table table-bordered table-hover">
  <thead className="">
    <tr>
      <th>Title</th>
      <th>File Name</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {documents.length === 0 ? (
      <tr>
        <td colSpan="3" className="text-center text-muted">No valid documents found.</td>
      </tr>
    ) : (
      documents.map((doc, index) => (
        <tr key={index}>
          <td>{doc.title}</td>
         <td>{doc.filePath?.split("/").pop().split("_").slice(1).join("_")}</td>

       <td>
  {/* 👁️ View */}
  <button
    className="btn btn-link"
  onClick={() => handleShowModal1(doc)}
    title="View Document"
  >
    <i className="fa fa-eye text-info"></i>
  </button>

  {/* ✏️ Edit — only for non-read-only users */}
  {!isReadOnly && (
    <label className="btn btn-link m-0" title="Update Document">
      <i className="fa fa-edit text-warning"></i>
  
<input
  type="file"
  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.webm"
  style={{ display: "none" }}
  onChange={(e) =>
    updateDocument(doc.resourceID, doc.title, e.target.files[0])
  }
/>

    </label>
  )}
   {/* ⬇️ Download */}
{/* ⬇️ Download */}
{doc.filePath && (
  <a
    href={doc.filePath}
    target="_blank"   // <-- open in new tab
    rel="noopener noreferrer"
    title="Download Document"
    className="btn btn-link"
  >
    <i className="fa fa-download text-primary"></i>
  </a>
)}

</td>

        </tr>
      ))
    )}
  </tbody>
</table>
<Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>{modalContent.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {modalContent.url ? renderAttachment(modalContent.url) : <p>No preview available.</p>}
  </Modal.Body>

</Modal>


    </ConsultantLayout>
  );
};

export default ListOfResources;
